import PT from 'prop-types';

export const UserType = PT.shape({
	name: PT.string,
	phoneNumber: PT.string,
	password: PT.string,
	isLoggedIn: PT.bool,
	isIpAllowed: PT.bool,
	isInitComplete: PT.bool,
	isSecurityCheckPassed: PT.bool,
	error: PT.string,
	fetching: PT.bool,
	role: PT.string,
	token: PT.string,
});
